import TabMenuList from './TabMenuList';
import useTabMenu from '@maxis/client-logic/hooks/useTabMenu';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { getLocalStorageItem } from '@maxis/client-logic/utils/localStorageUtil';
import { LOCAL_STORAGE_KEYS } from '@maxis/client-logic/constants/enumerates';

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
const TabContainer = () => {
    const { addTabMenu, closeAllTab } = useTabMenu();

    const userId = useBoundStore((state) => state.user.userId);
    const menuList = useBoundStore((state) => state.menu.menuList);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location?.pathname) {
            const m = menuList.find(
                (m) => import.meta.env.VITE_PUBLIC_URL + m.programRoutePath === location.pathname
            );
            if (m) {
                addTabMenu(m);
            } else {
                // 메인메뉴(홈버튼 클릭 등) 이동 시, 다른 탭이 닫혀서 주석
                // 버그 존재 시, 추가 작업 필요
                // closeAllTab();
            }
        }
    }, [location, menuList]);

    useEffect(() => {
        const accessToken = getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
        // accessToken이 있으면 세션 복원/유저 로드 전이라도 로그인 화면으로 보내지 않음 (E)
        if (!userId && !accessToken) {
            closeAllTab();
            navigate(import.meta.env.VITE_PUBLIC_URL + '/login', { replace: true });
        }
    }, [userId]);

    return <TabMenuList />;
};

export default TabContainer;
